import { useState } from 'react';
import { InputProps, FilledInputProps, OutlinedInputProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { BsEye, BsEyeSlash } from 'react-icons/bs';

import BaseInput, { BaseInputProps } from './BaseInput';

type PasswordInputProps = Omit<BaseInputProps, 'type' | 'InputProps'> & {
    InputProps?:
        | Partial<InputProps>
        | Partial<FilledInputProps>
        | Partial<OutlinedInputProps>
        | undefined;
};

const PasswordInput = ({ InputProps, ...rest }: PasswordInputProps) => {
    const [isVisible, setIsVisible] = useState<boolean>(false);

    const handleClickShowPassword = () => {
        setIsVisible((state) => !state);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (
        <BaseInput
            {...rest}
            type={isVisible ? 'text' : 'password'}
            slotProps={{
                ...rest.slotProps,
                input: {
                    ...InputProps,
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {isVisible ? (
                                    <BsEye color="#686868" />
                                ) : (
                                    <BsEyeSlash color="#686868" />
                                )}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
};

export default PasswordInput;
